var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1664 6.66698H17.4999C18.4204 6.66698 19.1666 7.41317 19.1666 8.33362V10.0873C19.1666 10.305 19.1239 10.5205 19.0411 10.7219L16.4624 16.9843C16.3338 17.2965 16.0295 17.5003 15.6918 17.5003H1.66659C1.20635 17.5003 0.833252 17.1272 0.833252 16.667V8.33362C0.833252 7.87341 1.20635 7.50032 1.66659 7.50032H4.56812C4.83889 7.50032 5.09278 7.36876 5.24893 7.14755L9.79342 0.709503C9.91217 0.541279 10.136 0.485022 10.3202 0.57711L11.8319 1.33297C12.7083 1.77116 13.1608 2.76081 12.9192 3.71033L12.1664 6.66698ZM5.83325 8.82321V15.8336H15.1338L17.4999 10.0873V8.33362H12.1664C11.0792 8.33362 10.2831 7.30944 10.5513 6.2558L11.304 3.29916C11.3523 3.10925 11.2618 2.91132 11.0865 2.82368L10.5356 2.54821L6.61054 8.10869C6.40229 8.40371 6.13609 8.64554 5.83325 8.82321ZM4.16658 9.16696H2.49992V15.8336H4.16658V9.16696Z",
    fill: "#2F3444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickUp);
export default __webpack_public_path__ + "static/media/quick-up.3e187bfef003d5e64700648d016ed2de.svg";
export { ForwardRef as ReactComponent };